type MemberScalingParams = { count: string; floor: string; total: string };

export const T = {
  en_GB: {
    triangleHeading: "Monthly income & expenses",
    triangleHeadingAnnual: "Income & expenses",
    triangleHelp: "Enter any two values — the third is calculated automatically.",
    triangleHelpAnnual:
      "Enter income and expenses — the surplus is calculated and converted to monthly automatically.",
    triangleHelpFromEntries: "Calculated based on values from the financial situation.",
    monthlyIncome: "Monthly income",
    monthlyExpenses: "Monthly expenses",
    monthlySurplus: "Monthly surplus",
    annualIncome: "Annual income",
    annualExpenses: "Annual expenses",
    deficitWarning: "Expenses exceed income — the client has a monthly deficit.",
    liquidityBuffer: "Liquidity buffer",
    bufferHelp: "The amount the client keeps as a reserve and does not invest.",
    bufferMinimum: "Minimum",
    bufferCustom: "Custom",
    bufferMemberScaling: (p: MemberScalingParams) => `${p.count} members × ${p.floor} = ${p.total}`,
    customBufferBelowMinimum: (amount: string) =>
      `The custom buffer is below the calculated minimum of ${amount}. Raise the amount, or choose Minimum.`,
    customBufferMissing: "Enter the custom buffer amount, or choose Minimum.",
    fixedBufferExplanation: "This amount follows from the client's data and cannot be changed.",
    amountPlaceholder: "Amount...",
    enterAmount: "Enter amount",
    shortTermExpenses: "Short-term expenses",
    shortTermHelp: "Amount earmarked for near-term spending.",
    availableForInvestments: "Available for investments",
    availableHelp: "Selected assets minus the liquidity buffer and short-term expenses.",
    insufficientAssets:
      "The selected assets do not cover the liquidity buffer and short-term expenses.",
  },
  nb_NO: {
    triangleHeading: "Månedlig inntekt og utgifter",
    triangleHeadingAnnual: "Inntekt og utgifter",
    triangleHelp: "Fyll inn to av verdiene — den tredje beregnes automatisk.",
    triangleHelpAnnual:
      "Fyll inn inntekt og utgifter — overskuddet beregnes og regnes om til månedlig automatisk.",
    triangleHelpFromEntries: "Beregnet ut fra verdiene i den finansielle situasjonen.",
    monthlyIncome: "Månedlig inntekt",
    monthlyExpenses: "Månedlige utgifter",
    monthlySurplus: "Månedlig overskudd",
    annualIncome: "Årlig inntekt",
    annualExpenses: "Årlige utgifter",
    deficitWarning: "Utgiftene overstiger inntekten — klienten har et månedlig underskudd.",
    liquidityBuffer: "Likviditetsbuffer",
    bufferHelp: "Beløpet klienten holder som reserve og ikke investerer.",
    bufferMinimum: "Minimum",
    bufferCustom: "Egendefinert",
    bufferMemberScaling: (p: MemberScalingParams) =>
      `${p.count} medlemmer × ${p.floor} = ${p.total}`,
    customBufferBelowMinimum: (amount: string) =>
      `Den egendefinerte bufferen er under beregnet minimum på ${amount}. Øk beløpet, eller velg Minimum.`,
    customBufferMissing: "Angi beløpet for den egendefinerte bufferen, eller velg Minimum.",
    fixedBufferExplanation: "Dette beløpet følger av klientens data og kan ikke endres.",
    amountPlaceholder: "Beløp...",
    enterAmount: "Angi beløp",
    shortTermExpenses: "Kortsiktige utgifter",
    shortTermHelp: "Beløp øremerket til forbruk i nær fremtid.",
    availableForInvestments: "Tilgjengelig for investering",
    availableHelp: "Valgte eiendeler minus likviditetsbuffer og kortsiktige utgifter.",
    insufficientAssets:
      "De valgte eiendelene dekker ikke likviditetsbufferen og kortsiktige utgifter.",
  },
} as const;
